import { Component, Input, Output, EventEmitter, ViewChild, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Configuration } from '../config';
import { SERVICE_CONFIG, IServiceConfig } from '../../service.config';

@Component({
    selector: 'system-settings',
    template: `<form #systemConfigFrom="ngForm" class="compact">
<section class="form-block" style="margin-top:0px;margin-bottom:0px;">
  <label style="font-size:14px;font-weight:600;" *ngIf="showSubTitle">{{'CONFIG.SYSTEM' | translate}}</label>
  <div class="form-group">
    <label for="proCreation">{{'CONFIG.PRO_CREATION_RESTRICTION' | translate}}</label>
    <div class="select">
        <select id="proCreation" name="proCreation" [(ngModel)]="systemSettings.project_creation_restriction.value" [disabled]="disabled(systemSettings.project_creation_restriction)">
            <option value="everyone">{{'CONFIG.PRO_CREATION_EVERYONE' | translate }}</option>
            <option value="adminonly">{{'CONFIG.PRO_CREATION_ADMIN' | translate }}</option>
        </select> 
    </div>
    <a href="javascript:void(0)" role="tooltip" aria-haspopup="true" class="tooltip tooltip-lg tooltip-top-right" style="top: -1px;">
        <clr-icon shape="info-circle" class="info-tips-icon" size="24"></clr-icon>
        <span class="tooltip-content">{{'CONFIG.TOOLTIP.PRO_CREATION_RESTRICTION' | translate}}</span>
    </a>
  </div>
  <div class="form-group">
      <label for="tokenExpiration" class="required">{{'CONFIG.TOKEN_EXPIRATION' | translate}}</label>
      <label for="tokenExpiration" aria-haspopup="true" role="tooltip" class="tooltip tooltip-validation tooltip-md tooltip-top-right" [class.invalid]="tokenExpirationInput.invalid && (tokenExpirationInput.dirty || tokenExpirationInput.touched)">
        <input name="tokenExpiration" type="text" #tokenExpirationInput="ngModel" [(ngModel)]="systemSettings.token_expiration.value" 
         required 
         pattern="^[1-9]{1}[0-9]*$"
         id="tokenExpiration" 
         size="20" [disabled]="!editable">
         <span class="tooltip-content">
               {{'TOOLTIP.NUMBER_REQUIRED' | translate}}
          </span>
       </label>
       <a href="javascript:void(0)" role="tooltip" aria-haspopup="true" class="tooltip tooltip-top-right">
         <clr-icon shape="info-circle" class="info-tips-icon" size="24"></clr-icon>
         <span class="tooltip-content">{{'CONFIG.TOOLTIP.TOKEN_EXPIRATION' | translate}}</span>
       </a>
   </div>
   <div class="form-group" *ngIf="canDownloadCert">
      <label for="certDownloadLink" class="required">{{'CONFIG.ROOT_CERT' | translate}}</label>
      <a #certDownloadLink [href]="downloadLink" target="_blank">{{'CONFIG.ROOT_CERT_LINK' | translate}}</a>
       <a href="javascript:void(0)" role="tooltip" aria-haspopup="true" class="tooltip tooltip-top-right">
         <clr-icon shape="info-circle" class="info-tips-icon" size="24"></clr-icon>
         <span class="tooltip-content">{{'CONFIG.TOOLTIP.ROOT_CERT_DOWNLOAD' | translate}}</span>
       </a>
   </div>
   <div *ngIf="!withAdmiral" class="form-group">
            <label for="repoReadOnly">{{'CONFIG.REPO_READ_ONLY' | translate}}</label>
            <clr-checkbox name="repoReadOnly" id="repoReadOnly" [clrChecked]="systemSettings.read_only.value"  (clrCheckedChange)="setRepoReadOnlyValue($event)">
                <a href="javascript:void(0)" role="tooltip" aria-haspopup="true" class="tooltip tooltip-top-right" style="top:-7px;">
                    <clr-icon shape="info-circle" class="info-tips-icon" size="24"></clr-icon>
                    <span class="tooltip-content">{{'CONFIG.TOOLTIP.REPO_TOOLTIP' | translate}}</span>
                </a>
            </clr-checkbox>
        </div>
</section>
</form>`,
    styles: [``, `.info-tips-icon{color:grey}.info-tips-icon:hover{color:#007cbb}`]
})
export class SystemSettingsComponent {
    config: Configuration;
    downloadLink: string = "/api/systeminfo/getcert";
    @Output() configChange: EventEmitter<Configuration> = new EventEmitter<Configuration>();

    @Input()
    get systemSettings(): Configuration {
        return this.config;
    }
    set systemSettings(cfg: Configuration) {
        this.config = cfg;
        this.configChange.emit(this.config);
    }

    @Input() showSubTitle: boolean = false;
    @Input() hasAdminRole: boolean = false;
    @Input() hasCAFile: boolean = false;
    @Input() withAdmiral = false;

    @ViewChild("systemConfigFrom") systemSettingsForm: NgForm;

    get editable(): boolean {
        return this.systemSettings &&
            this.systemSettings.token_expiration &&
            this.systemSettings.token_expiration.editable;
    }

    get isValid(): boolean {
        return this.systemSettingsForm && this.systemSettingsForm.valid;
    }

    setRepoReadOnlyValue($event: any) {
        this.systemSettings.read_only.value = $event;
    }

    disabled(prop: any): boolean {
        return !(prop && prop.editable);
    }

    get canDownloadCert(): boolean {
        return this.hasAdminRole && this.hasCAFile;
    }

    constructor( @Inject(SERVICE_CONFIG) private configInfo: IServiceConfig) {
        if (this.configInfo && this.configInfo.systemInfoEndpoint) {
            this.downloadLink = this.configInfo.systemInfoEndpoint + "/getcert";
        }
    }
}
